import {defaults, identity} from 'lodash';
import {anyPass} from '@packages/utilities/fp/utils';
import {has} from '@packages/utilities/key-map';
import tinycolor, {ColorInputWithoutInstance} from 'tinycolor2';

export const pixel = (v: number | string): number | string =>
  v && typeof v === 'number' ? v + 'px' : v;

export const translate = (
  x: number | string = 0,
  y: number | string = 0,
  z: number | string = 0
): string => `translate3d(${pixel(x)},${pixel(y)},${pixel(z)})`;

type CSSShadow = string;

export const shadow = (...args: Array<number | string>): CSSShadow =>
  args.map(pixel).join(' ');

export const margin = shadow;

export const rgba = (r: number, g: number, b: number, a: number): string =>
  a !== 1 ? `rgba(${r},${g},${b},${a})` : `rgb(${r},${g},${b})`;

export const white = (a: number = 1): string => rgba(255, 255, 255, a);
export const black = (a: number = 1): string => rgba(0, 0, 0, a);

export const fade =
  (multiplier: number): ((color: ColorInputWithoutInstance) => string) =>
  (color: ColorInputWithoutInstance): string => {
    const colorObject = tinycolor(color);
    return colorObject.setAlpha(colorObject.getAlpha() * multiplier).toString();
  };

export const list = (...args: Array<any>): string => args.join(',');

const hasMargin = has('margin');
const hasSideMargins = anyPass([
  has('marginTop'),
  has('marginRight'),
  has('marginBottom'),
  has('marginLeft'),
]);

type MarginStyles = {
  margin?: number | string;
  marginTop?: number | string;
  marginRight?: number | string;
  marginBottom?: number | string;
  marginLeft?: number | string;
};

export const adjustMargin = (
  amount: number
):
  | ((style: MarginStyles | undefined) =>
      | any
      | {
          margin: number;
        })
  | (<T>(value: T) => T) =>
  amount
    ? (style?: MarginStyles) => {
        if (!style) {
          return {margin: amount};
        }

        if (hasMargin(style)) {
          // @ts-expect-error - TS18048 - 'style.margin' is possibly 'undefined'. | TS2365 - Operator '+' cannot be applied to types 'string | number' and 'number'.
          return defaults({margin: style.margin + amount}, style);
        }

        if (!hasSideMargins(style)) {
          return defaults({margin: amount}, style);
        }

        return defaults(
          {
            // @ts-expect-error - TS2365 - Operator '+' cannot be applied to types 'string | number' and 'number'.
            marginTop: (style.marginTop || 0) + amount,
            // @ts-expect-error - TS2365 - Operator '+' cannot be applied to types 'string | number' and 'number'.
            marginRight: (style.marginRight || 0) + amount,
            // @ts-expect-error - TS2365 - Operator '+' cannot be applied to types 'string | number' and 'number'.
            marginBottom: (style.marginBottom || 0) + amount,
            // @ts-expect-error - TS2365 - Operator '+' cannot be applied to types 'string | number' and 'number'.
            marginLeft: (style.marginLeft || 0) + amount,
          },
          style
        );
      }
    : identity;
